import "./Main.css";
import Alena from "../../Photo/alena2.png";
import ButtonServ from "../Button/ButtonServ";
import Logo from "../../Photo/logo (2).png";

function Main() {
  return (
    <section className="main" id="Main" role="banner">
      {/* Декоративные элементы */}
      <div className="floating-dots"></div>
      <div className="floating-dots"></div>

      <div className="container">
        <div className="text">
          <div className="logo-container">
            <img
              className="logo-main"
              src={Logo}
              alt="Алена Трошина - Логотип"
            />
          </div>

          <h1 className="main-text color-text-main">
            Специалист <br />
            по красоте
          </h1>

          <p className="p-text-h color-text-main">
            Добро пожаловать на персональный сайт мастера!
          </p>

          <p className="p-text color-text-main">
            Я верю в важность индивидуального подхода к каждому клиенту. Перед
            началом любой процедуры я провожу детальную консультацию, чтобы
            понять ваши пожелания и ожидания. Это позволяет мне создавать именно
            тот результат, который будет вас радовать.
          </p>

          <div className="button-div">
            <a
              href="https://n1274061.yclients.com/company/687678/personal/menu?o=m1980662"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Записаться на прием через систему YClients"
            >
              <ButtonServ
                variant="primary"
                icon="sparkle"
                pulse={true}
                size="large"
              >
                Записаться онлайн
              </ButtonServ>
            </a>
          </div>
        </div>

        <div className="image-main">
          <img
            className="alena-m"
            src={Alena}
            alt="Алена Трошина - профессиональный мастер бьюти-индустрии"
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
}

export default Main;
